import {lazy,Suspense,type ReactNode} from 'react';
const PublicTournamentsPage=lazy(()=>import('./pages/PublicTournamentsPage').then(m=>({default:m.PublicTournamentsPage})));
const TournamentsPage=lazy(()=>import('./pages/TournamentsPage').then(m=>({default:m.TournamentsPage})));
function TournamentLoading({children}:{children:ReactNode}){return <Suspense fallback={<div className="panel-loading"><span className="spinner"/>Carregando campeonatos…</div>}>{children}</Suspense>;}
import {PublicLessonsPage} from './pages/PublicLessonsPage';
import {LessonsPage,LessonsEmbed} from "./pages/LessonsPage";
import {ReservationsPage,ReservationsEmbed} from './pages/ReservationsPage';
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth";
import { ErpPage } from "./pages/ErpPage";
import { SchedulingPage } from "./pages/SchedulingPage";
import { ProtectedLayout } from "./components/Layout";
import { LandingPage } from "./pages/LandingPage";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { AgendaPage } from "./pages/AgendaPage";
import { CourtsPage } from "./pages/CourtsPage";
import { CustomersPage } from "./pages/CustomersPage";
import { CategoriesPage } from "./pages/CategoriesPage";
import { ProductsPage } from "./pages/ProductsPage";
import { InventoryPage } from "./pages/InventoryPage";
import { TablesPage } from "./pages/TablesPage";
import { CashPage } from "./pages/CashPage";
import { SupportPage, SupportEmbed } from "./pages/SupportPage";
import { WhatsAppPage } from "./pages/WhatsAppPage";
import { DataDeletionPage, PrivacyPolicyPage } from "./pages/LegalPages";

export function App() {
  return (
    <Routes>
      <Route path="/campeonatos" element={<TournamentLoading><PublicTournamentsPage/></TournamentLoading>}/>
      <Route path="/campeonatos/:slug" element={<TournamentLoading><PublicTournamentsPage/></TournamentLoading>}/>
      <Route path="/aulas" element={<PublicLessonsPage/>}/>
      <Route path="/aulas-app" element={<LessonsEmbed />} />
      <Route path="/reservas-app" element={<ReservationsEmbed />} />
      <Route path="/atendimento-app" element={<SupportEmbed />} />
      <Route path="/" element={<LandingPage />} />
      <Route path="/politica-de-privacidade" element={<PrivacyPolicyPage />} />
      <Route path="/exclusao-de-dados" element={<DataDeletionPage />} />
      <Route path="/entrar" element={<LoginPage />} />
      <Route path="/painel" element={<ProtectedLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="campeonatos" element={<TournamentManagementPage/>}/>
        <Route path="campeonatos/:id" element={<TournamentManagementPage/>}/>
        <Route path="erp" element={<ManagementPage />} />
        <Route path="reservas" element={<ReservationsPage />} />
        <Route path="aulas" element={<LessonsPage />} />
        <Route path="agenda" element={<AgendaPage />} />
        <Route path="funcionamento" element={<SchedulingManagementPage />} />
        <Route path="quadras" element={<CourtsPage />} />
        <Route path="clientes" element={<CustomersPage />} />
        <Route path="categorias/*" element={<CategoriesPage />} />
        <Route path="produtos" element={<ProductsPage />} />
        <Route path="estoque" element={<InventoryPage />} />
        <Route path="mesas" element={<TablesPage />} />
        <Route path="caixa" element={<CashPage />} />
        <Route path="atendimento" element={<SupportPage />} />
        <Route path="whatsapp" element={<WhatsAppPage />} />
      </Route>
      <Route path="*" element={<LandingPage />} />
    </Routes>
  );
}

function ManagementPage() {
  const { user } = useAuth();
  return user && ["OWNER", "ADMIN"].includes(user.role) ? <ErpPage /> : <Navigate to="/painel" replace />;
}

function SchedulingManagementPage() {
  const { user } = useAuth();
  return user && ["OWNER", "ADMIN"].includes(user.role) ? <SchedulingPage /> : <Navigate to="/painel" replace />;
}

function TournamentManagementPage(){const {user}=useAuth();return user&&['OWNER','ADMIN'].includes(user.role)?<TournamentLoading><TournamentsPage/></TournamentLoading>:<Navigate to="/painel" replace/>;}
